import { useState } from 'react';
import type { RenderSettings, RenderVariant } from '../../types/property';

export function useRenderWorkflow() {
    const [isRenderWizardOpen, setIsRenderWizardOpen] = useState(false);
    const [isRenderPreviewOpen, setIsRenderPreviewOpen] = useState(false);

    const [renderWizardState, setRenderWizardState] = useState<{
        mode: 'create' | 'rerender';
        initialImageUrl?: string;
        initialImageId?: string;
        initialRoomName?: string;
        initialGcsPath?: string;
    }>({ mode: 'create' });

    // Selected Photo Data for Preview
    const [selectedPhotoData, setSelectedPhotoData] = useState<{
        roomName: string;
        variants: RenderVariant[];
        originalUrl?: string;
        renderSettings?: RenderSettings;
        originalGcsPath?: string;
        generationId?: string;
    } | null>(null);

    return {
        isRenderWizardOpen,
        setIsRenderWizardOpen,
        isRenderPreviewOpen,
        setIsRenderPreviewOpen,
        renderWizardState,
        setRenderWizardState,
        selectedPhotoData,
        setSelectedPhotoData
    };
}

